var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3H16.5C16.776 3 17 3.2235 17 3.5V4.5C17 4.6845 16.8985 4.854 16.736 4.941L9.236 8.9565C9.1625 8.996 9.081 9.0155 9 9.0155C8.919 9.0155 8.8375 8.996 8.764 8.9565L1.264 4.941C1.1015 4.854 1 4.6845 1 4.5V3.5C1 3.2235 1.224 3 1.5 3ZM9 10.0155C9.247 10.0155 9.492 9.95401 9.708 9.83801L16.988 5.94051C16.9891 5.94926 16.9914 5.95756 16.9937 5.96582C16.9969 5.97692 17 5.98798 17 6.00001V14.5C17 14.7765 16.776 15 16.5 15H1.5C1.224 15 1 14.7765 1 14.5V6.00001C1 5.98795 1.00313 5.97671 1.00628 5.96545C1.0086 5.9571 1.01094 5.94874 1.012 5.94001L8.2915 9.83801C8.508 9.95401 8.753 10.0155 9 10.0155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.cf6560285aef8643fc8c29a28c0d340f.svg";
export { ForwardRef as ReactComponent };